import { api } from './api';
import { PostFeedbackInputModel } from '../types/FeedbackModels';

export const postFeedback = async (
  model: PostFeedbackInputModel,
  token: string
): Promise<void> => {
  try {
    await api.post('/v1/feedback/post-feedback', model, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  } catch (error) {
    console.error('Error posting feedback:', error);
    throw error;
  }
};
